import { Box, LinearProgress, Typography } from "@mui/material";

export function ProgressLabel() {
  return (
    <Box className="w-90" margin="10px">
      <LinearProgress style={{ backgroundColor: "gray", color:"#7159EA" }} value={5} />
      <Box className="mb-2 flex items-center justify-between gap-4">
        <Typography className="text-gray-400"
            variant="h6"
            sx={{
                fontSize:"14px"
            }}
            gutterBottom
        >
          $5
        </Typography>
        <Typography 
            className="text-gray-400"
            variant="h6"
            sx={{
                fontSize:"14px"
            }}
        >
          $500
        </Typography>
      </Box>
    </Box>
  );
};
